<template>
    <div class="stat-box">
        <el-dropdown style="width: 100%" v-if="scaleStatsList && scaleStatsList.length > 0" slot="dropdown">
            <div class="stat-title" style="">
                 {{scaleTitle}}⇅
            </div>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item :disabled="scaleId===item.scaleId" v-for="item in scaleStatsList" @click="changeScale(item)">{{item.title}}</el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
        <el-tabs v-model="activeTabName" @tab-click="handleTabsClick" type="border-card">
            <el-tab-pane label="统计结果" name="0" >
                <div v-if="questionList.length===0" class="data-empty">
                    <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                    <div class="empty-title">暂无数据</div>
                </div>
                <div v-for="(item,index) in questionList" :style="index==0?'margin-top:-10px;':''">
                    <h3 style="margin: 10px 0 10px 0;">
                            <span>
                                {{ index + 1 }}.{{item.questionName }}
                            </span>
                        <span style="height:22px;line-height:22px;color: #999;font-weight: normal;font-size: 14px;">
                                [{{item.type == 1 ? '单选' : item.type == 2 ? '多选' : item.type == 3 ? '评分' : item.type == 4 ? '文字内容' : '' }}]
                            </span>
                    </h3>
                    <el-table v-if="item.type==1 || item.type==2"
                              :data="item.answerList"
                              :row-class-name="hideStat"
                              border fit>
                        <el-table-column  align="center" label="选项" prop="itemName"/>
                        <el-table-column  align="center" label="小计" prop="answerCount"/>
                        <el-table-column  align="center" label="比例" prop="rate">
                            <template #default="scope">
                                <div>{{scope.row.rate * 100}}%</div>
                            </template>
                        </el-table-column>
                        <template #append>
                            <div style="display: flex">
                                <div style="width: 100%;height: 40px;line-height: 40px;font-weight: bold;text-align: center;">
                                    本题有效填写人次：{{item.count}}<span v-if="item.score&&item.score>0">，平均分：{{item.score}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table>
                    <div class="chart-tab" v-if="item.type!=3 && item.type!=4">
                        <ul class="fr">
                            <li @click="handlePieQuestion(item.questionId)" :class="this.pieQuIds.includes(item.questionId)?'liSel':''">
                                饼状
                            </li>
                            <li @click="handleBarQuestion(item.questionId)" :class="this.barQuIds.includes(item.questionId)?'liSel':''">
                                柱状
                            </li>
                        </ul>
                    </div>

                    <pieEcharts v-if="item.type!=3 && item.type!=4 && this.pieQuIds.includes(item.questionId)"
                                :id="item.questionId+'_pie'"
                                :dataList="item.answerList"/>

                    <barEcharts v-if="item.type!=3 && item.type!=4 && this.barQuIds.includes(item.questionId)"
                                :id="item.questionId+'_bar'"
                                :dataList="item.answerList"/>


                    <el-table v-if="item.type==3" :data="item.aveScore" border fit>
                        <el-table-column  align="center" label="打分人数" prop="trueName">
                            <div>{{item.count}}</div>
                        </el-table-column>
                        <el-table-column  align="center" label="平均分" >
                            <template #default="scope">
                                <div>{{scope.row}}</div>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-table v-if="item.type==4" :data="item.userAnswerList" border fit>
                        <el-table-column  align="center" label="姓名" prop="trueName">
                            <template #default="scope">
                                <div>{{scope.row.isHide==0?scope.row.trueName:'匿名'}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column  align="center" label="内容" prop="answerName" />
                    </el-table>

                </div>
            </el-tab-pane>
            <el-tab-pane label="详细数据" name="1" >
                <div v-if="userRecordList.length===0" class="data-empty">
                    <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                    <div class="empty-title">暂无数据</div>
                </div>
                <div v-if="userRecordList.length!==0" class="stat-data-title">
                    量表提交人数：{{userRecordList.length}}，平均分：{{this.aveScore}}
                </div>
                <el-collapse v-if="userRecordList.length!==0" v-model="activeNames" accordion>
                    <el-collapse-item v-for="(item,index) in userRecordList" :name="index+1"
                                      @click.native="handleChange(index)">
                        <template #title>
                            <h3 style="margin: 0 0;" :class="activeIndex==index?'user-record-title active':'user-record-title'">
                                {{item.isHide==0?(index+1)+'.'+item.trueName:(index+1) +'.匿名'}}
                                提交时间: {{timestampToTime(item.submitTime)}}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: red;!important;">{{item.totalScore?'总分：'+item.totalScore:''}}</span>
                            </h3>
                        </template>
                        <div v-for="(q,i) in item.questionList">
                            <h3 style="margin: 10px 0 10px 0;color:#909399 ">
                                    <span>
                                        {{ i + 1 }}.{{q.questionName }}
                                    </span>
                                <span style="height:22px;line-height:22px;color: #999;font-weight: normal;font-size: 14px;">
                                        [{{q.type == 1 ? '单选' : q.type == 2 ? '多选' : q.type == 3 ? '评分' : q.type == 4 ? '文字内容' : '' }}]
                                    </span>
                            </h3>
                            <div style="margin-left: 10px">
                                {{q.questionAnswer}}
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import {timestampToTime} from "@/utils/date";
import {appStatsEvaLesson} from "@/api/admin/stats";
import pieEcharts from "@/components/echart/pieEcharts.vue";
import barEcharts from "@/components/echart/barEcharts.vue";

export default {
    name: "homeEvaStat",
    components: {barEcharts, pieEcharts},
    data() {
        return {
            timestampToTime,
            //听评课量表统计
            aveScore:0,
            lessonId:'',
            scaleId:'',
            activeTabName:'0',
            activeIndex:null,
            activeNames:'',
            scaleTitle:'',
            evaLessonTitle:'', //当前听评课标题
            userRecordList:[], //当前量表填写记录
            questionList:[],  //当前量表问题统计
            scaleStatsList:[], //量表 统计数据
            pieQuIds:'', //饼图问题ID
            barQuIds:'', //柱状图问题ID
        };
    },
    created() {},
    mounted() {
        if (this.$route.query.lessonId) {
            this.lessonId = this.$route.query.lessonId;
            this.queryRateScale()
        }
    },
    computed: {},
    methods: {
        queryRateScale(){
            this.activeIndex = null
            this.userRecordList = []
            this.questionList = []
            appStatsEvaLesson({lessonId:this.lessonId}).then(res => {
                if (res.data.code === 1){
                    this.scaleStatsList = res.data.data;
                    if (this.scaleStatsList){
                        this.scaleId = this.scaleStatsList[0].scaleId;
                        this.scaleTitle = this.scaleStatsList[0].title;
                        this.userRecordList = this.scaleStatsList[0].userRecordList;
                        this.questionList = this.scaleStatsList[0].questionList;
                        this.aveScore = this.scaleStatsList[0].score
                        this.pieQuIds = ''
                        this.barQuIds = ''
                        this.questionList.forEach(q  => {
                            this.pieQuIds = this.pieQuIds+q.questionId
                        })
                    }
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleTabsClick(item){
            this.activeTab = item.name;
        },
        changeScale(item)  {
            const sId = item.scaleId;
            this.scaleId = item.scaleId;
            this.scaleTitle = item.title;
            this.isRateScaleShow = true;
            this.activeIndex = null
            this.userRecordList = []
            this.questionList = []
            this.pieQuIds = ''
            this.barQuIds = ''
            appStatsEvaLesson({lessonId:this.lessonId}).then(res => {
                if (res.data.code === 1){
                    this.scaleStatsList = res.data.data;
                    if (this.scaleStatsList){
                        this.scaleStatsList.forEach(e => {
                            if (sId===e.scaleId){
                                this.scaleId = e.scaleId;
                                this.scaleTitle = e.title;
                                this.userRecordList = e.userRecordList;
                                this.questionList = e.questionList;
                                this.aveScore = e.score
                                this.pieQuIds = ''
                                this.barQuIds = ''
                                this.questionList.forEach(q  => {
                                    this.pieQuIds = this.pieQuIds+q.questionId
                                })
                            }
                        })
                    }
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handlePieQuestion(qId){
            if (!this.pieQuIds.includes(qId)){
                this.pieQuIds = this.pieQuIds+qId;
            }
            if (this.barQuIds.includes(qId)){
                this.barQuIds = this.barQuIds.replace(qId,'');
            }
        },
        handleBarQuestion(qId){
            if (!this.barQuIds.includes(qId)){
                this.barQuIds = this.barQuIds +qId;
            }
            if (this.pieQuIds.includes(qId)){
                this.pieQuIds = this.pieQuIds.replace(qId,'');
            }
        },
        handleChange(index){
            this.activeIndex = index
        },
        hideStat({ row, rowIndex }){
            if (row.answerCount===0){
                // return 'hidden-row'
                return '';
            }
            return '';
        },
    },

}

</script>

<style scoped>
.stat-box{
    height:100vh;
    overflow: auto;
    scrollbar-width: none;
}
.stat-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: #3b62f8;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
}
.stat-box::-webkit-scrollbar {
    display: none;
}
.chart-tab{
    display: flex;
    text-align: center;
    margin: 5px 0;
    color: #333;
}
.chart-tab ul{
    background: #ebebeb;
    padding: 0 2px;
    list-style: none;
    border: none;
    margin: 0;
    display: block;
}
.chart-tab ul li{
    float: left;
    height: 28px;
    line-height: 26px;
    text-align: center;
    background: #fff;
    border-radius: 2px;
    margin: 2px 1px;
    cursor: pointer;
    padding: 0 4px
}
.fr{
    float: right;
}
.liSel{
    background: #fff;
    box-shadow: 0 1px 2px 0 #d9d9d9;
    border-radius: 1px;
    color: #1f89de;
    font-weight: bold;
}
.txt-icon{
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 400 !important;
    text-decoration: none;
}
.txt-vam{
    vertical-align: middle;
}

.stat-data-title{
    height: 30px;
    font-size: 15px;
    color: #3b62f8;
    font-weight: bold;
}
</style>